import { useEffect } from "react";
import { Card, Typography, Row, Col, Button } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { getBusinessPortalKycRedirectUrl } from "../../../helpers/businessPortal";

const { Title, Paragraph } = Typography;

const REDIRECT_DELAY_MS = 3000;

const KycSuccess = ({
  onClose,
  onGotoDashboard,
  isAlreadyCompleted,
  autoRedirect = true,
}) => {
  const goToBusinessModule = () => {
    if (typeof onGotoDashboard === "function") {
      onGotoDashboard();
      return;
    }
    window.location.assign(getBusinessPortalKycRedirectUrl());
  };

  useEffect(() => {
    if (!autoRedirect || isAlreadyCompleted) return undefined;

    const timer = setTimeout(() => {
      goToBusinessModule();
    }, REDIRECT_DELAY_MS);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoRedirect, isAlreadyCompleted]);

  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card style={{ width: 560, borderRadius: 8, textAlign: "center" }}>
        <Row justify="center">
          <Col>
            <CheckCircleTwoTone
              twoToneColor="#52c41a"
              style={{ fontSize: 56 }}
            />
          </Col>
        </Row>

        <Title level={4} style={{ marginTop: 12 }}>
          {isAlreadyCompleted ? "KYC Already Completed" : "KYC Successful"}
        </Title>
        <Paragraph type="secondary">
          {isAlreadyCompleted
            ? "Your KYC has already been completed."
            : "Your KYC has been submitted successfully and is under review. We will notify you once it is approved."}
        </Paragraph>

        <Button
          type="primary"
          style={{ backgroundColor: "#00874F", marginTop: 8 }}
          onClick={() => {
            if (typeof onClose === "function") onClose();
            goToBusinessModule();
          }}
        >
          Go to Business Module
        </Button>
      </Card>
    </div>
  );
};

export default KycSuccess;
